export enum ManagedPostProvider {
  Instagram = 'INSTAGRAM',
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE',
}
